import React from "react";

const DimensionLabel = (props)=>{
	let style = {};
	const label = (props.label || "")+"";
	if(label && label.indexOf("Total") === 0){
		style = {...style, fontWeight:"bold"}
	}

	return <div style={style}>{label}</div>;
}

export default DimensionLabel;



// WEBPACK FOOTER //
// src/modules/stats/containers/summary/Dimension/DimensionLabel.js